import React from 'react';
import classes from './classes.module.scss';
import AppLink from '../../../routes/app_link';
import { SvgIcon } from '../../../../../common/sprites';

const renderSeeAllBtnText = ({ showMore, slug, params }) => {
  if (!showMore || !slug) return null;
  const seeAllBtnText = showMore.title ? (
    <div className={ classes.seeAllBtnTextContainer }>
      { showMore.subtitle }
      {` (${ showMore.title })`}
      <SvgIcon className={ classes.seeAllBtnRightArrow } id="right_arrow" size={ 12 } />
    </div>
  ) : (
    showMore.subtitle
  );
  return (
    <AppLink
      to={ {
        pathname: slug,
        state: {
          needRefresh: true,
          params
        }
      } }
      className={ classes.seeAllBtn }
    >
      { seeAllBtnText }
    </AppLink>
  );
};

const renderTitleTextSection = ({
  title, iconUrl, slug, params
}) => {
  if (slug) {
    return (
      <AppLink
        to={ {
          pathname: slug,
          state: {
            needRefresh: true,
            params
          }
        } }
        rel="nofollow"
      >
        <h2 className={ classes.advisorTitleText } style={ !iconUrl ? { marginLeft: '0px' } : {} }>
          { title ||  <div className={ classes.advisorTitleTextSkeleton } /> }
        </h2>
      </AppLink>
    );
  }
  return (
    <h2 className={ classes.advisorTitleText } style={ !iconUrl ? { marginLeft: '0px' } : {} }>
      { title || <div className={ classes.advisorTitleTextSkeleton } /> }
    </h2>
  );
};

const getIconUrlStyle = (iconUrl) => {
  if (!iconUrl) return { display: 'none' };
  return {};
};

function AdvisorSectionTitle({
  title,
  loading,
  iconUrl,
  description,
  shortDescription,
  showMore,
  slug,
  theme,
  params
}) {
  const renderSectionTitle = () => {
    if (!title && !loading) return null;
    return (
      <div className={ classes.advisorTitleContainer }>
        <div style={ { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } } suppressHydrationWarning>
          <div className={ classes.advisorTitle }>
            <img src={ iconUrl } alt="" className={ classes.advisorTitleImg } style={ getIconUrlStyle(iconUrl) } />
            { renderTitleTextSection({
              title, iconUrl, slug, params
            }) }
          </div>
          { renderSeeAllBtnText({ showMore, slug, params }) }
        </div>
        <div className={ classes.advisorTitleDescription }>
          { description || <div className={ classes.advisorDescriptionSkeleton } /> }
        </div>
        <div className={ classes.advisorShortDescription }>
          { shortDescription || <div className={ classes.advisorShortDescriptionSkeleton } /> }
        </div>
      </div>
    );
  };
  return (
    <div className={ classes[theme] } data-testid={ `${ theme }-title` }>
      { renderSectionTitle() }
    </div>
  );
}

export default AdvisorSectionTitle;
